<template>
  <div class="media-upload">
    <el-upload
      class="upload"
      :action="uploadUrl"
      :accept="accept"
      :auto-upload="true"
      :headers="headers"
      :limit="limit"
      :multiple="multiple"
      list-type="picture-card"
      :file-list="innerList"
      :before-upload="beforeUpload"
      :on-exceed="handleExceed"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :on-success="handleUploadSuccess"
    >
      <i class="el-icon-plus"></i>
      <!-- 自定义反显 -->
      <template v-slot:file="{ file }">
        <!-- 图片 -->
        <img v-if="file.type==1" class="el-upload-list__item-thumbnail" :src="baseUrl + file.url" />
        <!-- 视频 -->
        <img v-else-if="file.type==2" class="el-upload-list__item-thumbnail" :src="file.thumb || baseUrl + videoIcon" />
        <!-- 音频 -->
        <img v-else class="el-upload-list__item-thumbnail" :src="baseUrl + audioIcon" />
        <span class="el-upload-list__item-actions">
          <!--预览-->
          <span class="el-upload-list__item-preview" @click="handlePreview(file)">
            <i class="el-icon-view"></i>
          </span>
          <!--移除-->
          <span class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </template>
    </el-upload>

    <media-preview ref="mediaPreview"></media-preview>
  </div>
</template>

<script>
export default {
  name: 'MediaUpload',
  props: {
    uploadUrl: {
      type: String,
      default: "/dev-api/common/upload"
    },
    accept: {
      type: String,
      default: 'image/*,video/*,audio/*'
    },
    limit: {
      type: Number,
      default: 10
    },
    size: {
      type: Number,
      default: 10
    },
    multiple: {
      type: Boolean,
      default: true
    },    
    value: {
      type: String, // 逗号分隔的url
      default: ""
    }
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$store.getters.token
      };
    }
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      innerList: [],
      videoIcon: '/profile/images/video.png',
      audioIcon: '/profile/images/audio.png'
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.innerList = [];
          return;
        }
        const arr = val.split(",");
        this.innerList = arr.map(url => ({
          name: url.split("/").pop(),
          url,
          type: this.getFileType(url),
          status: "success"
        }));
      }
    }
  },
  methods: {
    // 文件类型判断
    getFileType(fileName) {
      const ext = fileName.split('.').pop().toLowerCase();
      if (['jpg','jpeg','png','gif','webp'].includes(ext)) return 1;
      if (['mp4','mkv','wmv','mov','webm'].includes(ext)) return 2;
      if (['mp3','wav','aac','m4a'].includes(ext)) return 3;
      return -1;
    },
    // 上传前校验
    beforeUpload(file) {
      let type=this.getFileType(file.name)
      //类型限制
      if (type==-1) {
        this.$message.error("只能上传图片、视频或音频！");
        return false;
      }
      //大小限制
      if (file.size / 1024 / 1024 > this.size) {
        this.$message.error("文件大小不能超过"+this.size+"MB！");
        return false;
      }      
      return true;
    },
    // 同步 v-model
    updateValue() {
      const urls = this.innerList.map(i => i.url).join(",");
      this.$emit("input", urls);
    },
    handleExceed(files, fileList) {
      this.$message.error(`最多允许上传 ${this.limit} 个文件！`);
    },
    // 上传成功
    handleUploadSuccess(res, file, fileList) {
      file.url =res.fileName; // 后端返回字段
      this.innerList = [...fileList];
      this.updateValue();
    },
    // 删除
    handleRemove(file) {
      const index = this.innerList.findIndex(i => i.url === file.url);
      if (index !== -1) this.innerList.splice(index, 1);
      this.updateValue();
    },
    // 预览
    handlePreview(file) {
      const index = this.innerList.findIndex(i => i.url === file.url);
      const files = this.innerList.map(i => this.baseUrl + i.url);
      this.$refs.mediaPreview.open(files, index);
    }
  }
};
</script>
